var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-wallet"},[_c('wallet-menu',{attrs:{"use-bottom-menu":""}}),_c('div',{staticClass:"narrow-container"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }